import { render, staticRenderFns } from "./FlightSectionSectionsCollapse.vue?vue&type=template&id=97820834&scoped=true&"
import script from "./FlightSectionSectionsCollapse.vue?vue&type=script&lang=js&"
export * from "./FlightSectionSectionsCollapse.vue?vue&type=script&lang=js&"
import style0 from "./FlightSectionSectionsCollapse.vue?vue&type=style&index=0&id=97820834&prod&lang=css&"
import style1 from "./FlightSectionSectionsCollapse.vue?vue&type=style&index=1&id=97820834&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97820834",
  null
  
)

export default component.exports